export class SECURITYQS {
    secQueList: any;
    answer: string;
    userLoginId: string;
    screenId: number;
    updatedBy: string;
    activity: string;
}
